
    import store from '@/store';
    import { Options, Vue } from 'vue-class-component';
    
    @Options({
      components:{
      },
      props: {
       
      }
    })
    export default class Orders extends Vue {
      tableFields= [
      {
            key: 'id',
            label: 'Id',
            sortable: false
          },
      {
            key: 'orderCode',
            label: 'Code',
            sortable: false
          },
          {
            key: 'date',
            sortable: true
          },
          {
            key: 'amount',
            sortable: true
          },
          {
            key: 'totalItems',
            label: 'Total Items',
            sortable: true
          }
          
        ]
       get orders() {
        return store.getters.orders;
    }
  }
    